import { LoadingPage } from "@features/loading/pages/LoadingPage";
import { DYNAMIC_IMPORT_SSR } from "@utils/constants";
import dynamic from "next/dynamic";

export const CategoryDetailsPage = dynamic(
  () => import("./index").then((x) => x.CategoryDetailsPage),
  {
    ssr: DYNAMIC_IMPORT_SSR,
    loading: () => {
      return <LoadingPage />;
    },
  }
);
